import { Mail, Phone, MapPin, Instagram } from "lucide-react";
import { brand, socialLinks } from "@/data/site";
import { WhatsAppIcon } from "@/components/icons";

export default function Contact() {
    return (
        <div data-testid="page-contact" className="wx-container py-10">
            <h1 className="text-2xl font-semibold text-[color:var(--wx-ink)] tracking-tight">
                Kontak
            </h1>
            <p className="mt-2 text-sm text-[color:var(--wx-muted)]">
                Tim resmi {brand.name} siap membantu. Untuk respons paling
                cepat gunakan WhatsApp.
            </p>

            <div className="mt-5 grid gap-2">
                <a
                    href={socialLinks.whatsappOrder}
                    target="_blank"
                    rel="noreferrer"
                    data-testid="contact-wa"
                    className="wx-link-row"
                >
                    <span className="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-[#25D366]/10 text-[#128C7E]">
                        <WhatsAppIcon className="w-5 h-5" />
                    </span>
                    <span className="flex-1">
                        <span className="block text-[11px] wx-eyebrow">
                            WhatsApp
                        </span>
                        <span className="block text-sm font-semibold text-[color:var(--wx-ink)]">
                            {brand.phone}
                        </span>
                    </span>
                </a>
                <a
                    href={`mailto:${brand.email}`}
                    data-testid="contact-email"
                    className="wx-link-row"
                >
                    <span className="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-[color:var(--wx-blueSoft)] text-[color:var(--wx-blue)]">
                        <Mail className="w-5 h-5" />
                    </span>
                    <span className="flex-1">
                        <span className="block text-[11px] wx-eyebrow">
                            Email
                        </span>
                        <span className="block text-sm font-semibold text-[color:var(--wx-ink)]">
                            {brand.email}
                        </span>
                    </span>
                </a>
                <a
                    href={socialLinks.instagram}
                    target="_blank"
                    rel="noreferrer"
                    data-testid="contact-ig"
                    className="wx-link-row"
                >
                    <span className="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-gradient-to-tr from-[#F58529] via-[#DD2A7B] to-[#8134AF] text-white">
                        <Instagram className="w-5 h-5" />
                    </span>
                    <span className="flex-1">
                        <span className="block text-[11px] wx-eyebrow">
                            Instagram
                        </span>
                        <span className="block text-sm font-semibold text-[color:var(--wx-ink)]">
                            @wxfaous
                        </span>
                    </span>
                </a>
                <a
                    href={`tel:+${brand.phoneRaw}`}
                    data-testid="contact-phone"
                    className="wx-link-row"
                >
                    <span className="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-[color:var(--wx-blueSoft)] text-[color:var(--wx-blue)]">
                        <Phone className="w-5 h-5" />
                    </span>
                    <span className="flex-1">
                        <span className="block text-[11px] wx-eyebrow">
                            Telepon
                        </span>
                        <span className="block text-sm font-semibold text-[color:var(--wx-ink)]">
                            {brand.phone}
                        </span>
                    </span>
                </a>
            </div>

            <div className="mt-6 wx-card p-4">
                <p className="wx-eyebrow">Alamat Bisnis</p>
                <div className="mt-2 flex items-start gap-2 text-sm text-[color:var(--wx-ink2)] leading-relaxed">
                    <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-[color:var(--wx-blue)]" />
                    <span>
                        <span className="text-[color:var(--wx-ink)] font-medium">
                            {brand.legal}
                        </span>
                        <br />
                        {brand.address.line1}
                        <br />
                        {brand.address.line2}
                        <br />
                        {brand.address.city}, {brand.address.province}{" "}
                        {brand.address.postal}
                        <br />
                        {brand.address.country}
                    </span>
                </div>
            </div>
        </div>
    );
}
